export function charLimit(data, limit) {
  return data?.length > limit ? data.substring(0, limit + 1) + '...' : data
}
